// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.sharing-modal-tabs li a {
    color: #a6a3a3 !important;
    font-weight: 500;
}

.sharing-modal-tabs li a.active {
    color: #6c2fbb !important;
    border-top: 3px solid #6c2fbb !important;
    border-bottom: 0 !important;
    border-radius: 0;
}

.sharing-modal-body {
    padding: 15px;
    padding-bottom: 0px;
}

.search-users {
    margin-top: 40px;
}

.simirl-video:hover {
    color: #6c2fbb;
}

.search-users form input {
    margin-right: 15px;
    width: 74%;
}

button.startOver {
    position: absolute;
    top: -30px;
    background: transparent;
    border: 0;
    padding: 0;
    padding: 5px 13px;
    font-size: 14px;
    right: 0;
    color: #fff;
    z-index: 9;
}

.share-btn {
    padding: 6px 25px !important;
    background-color: #6c2fbb;
    color: #ffffff;
    border-color: #6c2fbb;
}

.sharing-links {
    list-style-type: none;
    padding: 0;
    text-align: center;
    margin-top: 40px;
    margin-bottom: 40px;
}

.sharing-links li {
    display: inline-block;
    /* margin-right: 12px; */
    margin-left: 20px;
    cursor: pointer;
}

.user-list-item {
    width: 100%;
    text-align: left;
    margin-right: 30px;
}

.sharing-links li img {
    width: 50px;
    height: 50px;
}

.sharing-links li p {
    font-size: 12px;
    color: #a6a3a3;
}

.animations div{
    background-color: black;
    border-radius: 4px;
    height: 50px;
    width: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.animations div img{
    height: 45px;
    width: 40px;
}

.p-text {
    text-align: left;
    font-size: 13px !important;
    color: #a6a3a3;
}


/*follower users list*/
.follow-share {
    /*padding: 5px 20px;*/
    position: relative;
    /*margin-bottom: 15px;*/
    cursor: pointer;
    display: flex;
    align-items: center;
    margin-bottom: 3px;
}

.follow-share img {
    /*border-radius: 50%;*/
    border-radius: 10px;
    min-width: 50px;
    /*position: absolute;*/
    /*left: 20px;*/
    /*top: 0;*/
    object-fit: cover;
    margin-right: 10px;
}

.follow-share h5 {
    font-size: 14px;
    margin-bottom: 0;
    /*padding-left: 60px;*/
    /*margin-top: 12px;*/
}

.follow-share.selected-share:before {
    content: "\\2713";
    display: inline-block;
    color: #fff;
    position: absolute;
    top: 5px;
    align-items: center;
    text-align: center;
    left: 20px;
    background: #6e5eff;
    width: 50px;
    height: 50px;
    /*border-radius: 50%;*/
    border-radius: 10px;
    font-size: 30px;
    z-index: 9;
    opacity: 0.7;
    line-height: 52px;
}

.follow-share.selected-share h5 {
    color: #6e5eff;
}

.follow-share .profile-image {
    width: 50px;
    min-width: 50px;
    height: 50px;
    font-size: 22px;
    line-height: 30px;
    margin-right: 10px;
}

.mediaTitle{
    color: black !important;
    font-weight: 900;
}

::ng-deep .mat-checkbox input {
    top: 2px !important;
    left: 2px !important;
}

@media only screen and (max-width: 576px) and (min-width: 320px) {
    ::ng-deep .mat-dialog-content{
        padding: 0;
    }

    .search-users {
        margin-top: 18px;
    }
    .form-inline {
        flex-flow: nowrap;
    }
    }`, "",{"version":3,"sources":["webpack://./src/app/layout/modals/share-video-dialog/share-video-dialog.component.css"],"names":[],"mappings":";AACA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,wCAAwC;IACxC,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,uBAAuB;IACvB,SAAS;IACT,UAAU;IACV,iBAAiB;IACjB,eAAe;IACf,QAAQ;IACR,WAAW;IACX,UAAU;AACd;;AAEA;IACI,4BAA4B;IAC5B,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;IACxB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,cAAc;AAClB;;;AAGA,sBAAsB;AACtB;IACI,qBAAqB;IACrB,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,sBAAsB;IACtB,cAAc;IACd,UAAU;IACV,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,UAAU;IACV,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,gBAAgB;IACpB;IACA;QACI,iBAAiB;IACrB;IACA","sourcesContent":["\n.sharing-modal-tabs li a {\n    color: #a6a3a3 !important;\n    font-weight: 500;\n}\n\n.sharing-modal-tabs li a.active {\n    color: #6c2fbb !important;\n    border-top: 3px solid #6c2fbb !important;\n    border-bottom: 0 !important;\n    border-radius: 0;\n}\n\n.sharing-modal-body {\n    padding: 15px;\n    padding-bottom: 0px;\n}\n\n.search-users {\n    margin-top: 40px;\n}\n\n.simirl-video:hover {\n    color: #6c2fbb;\n}\n\n.search-users form input {\n    margin-right: 15px;\n    width: 74%;\n}\n\nbutton.startOver {\n    position: absolute;\n    top: -30px;\n    background: transparent;\n    border: 0;\n    padding: 0;\n    padding: 5px 13px;\n    font-size: 14px;\n    right: 0;\n    color: #fff;\n    z-index: 9;\n}\n\n.share-btn {\n    padding: 6px 25px !important;\n    background-color: #6c2fbb;\n    color: #ffffff;\n    border-color: #6c2fbb;\n}\n\n.sharing-links {\n    list-style-type: none;\n    padding: 0;\n    text-align: center;\n    margin-top: 40px;\n    margin-bottom: 40px;\n}\n\n.sharing-links li {\n    display: inline-block;\n    /* margin-right: 12px; */\n    margin-left: 20px;\n    cursor: pointer;\n}\n\n.user-list-item {\n    width: 100%;\n    text-align: left;\n    margin-right: 30px;\n}\n\n.sharing-links li img {\n    width: 50px;\n    height: 50px;\n}\n\n.sharing-links li p {\n    font-size: 12px;\n    color: #a6a3a3;\n}\n\n.animations div{\n    background-color: black;\n    border-radius: 4px;\n    height: 50px;\n    width: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.animations div img{\n    height: 45px;\n    width: 40px;\n}\n\n.p-text {\n    text-align: left;\n    font-size: 13px !important;\n    color: #a6a3a3;\n}\n\n\n/*follower users list*/\n.follow-share {\n    /*padding: 5px 20px;*/\n    position: relative;\n    /*margin-bottom: 15px;*/\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    margin-bottom: 3px;\n}\n\n.follow-share img {\n    /*border-radius: 50%;*/\n    border-radius: 10px;\n    min-width: 50px;\n    /*position: absolute;*/\n    /*left: 20px;*/\n    /*top: 0;*/\n    object-fit: cover;\n    margin-right: 10px;\n}\n\n.follow-share h5 {\n    font-size: 14px;\n    margin-bottom: 0;\n    /*padding-left: 60px;*/\n    /*margin-top: 12px;*/\n}\n\n.follow-share.selected-share:before {\n    content: \"\\2713\";\n    display: inline-block;\n    color: #fff;\n    position: absolute;\n    top: 5px;\n    align-items: center;\n    text-align: center;\n    left: 20px;\n    background: #6e5eff;\n    width: 50px;\n    height: 50px;\n    /*border-radius: 50%;*/\n    border-radius: 10px;\n    font-size: 30px;\n    z-index: 9;\n    opacity: 0.7;\n    line-height: 52px;\n}\n\n.follow-share.selected-share h5 {\n    color: #6e5eff;\n}\n\n.follow-share .profile-image {\n    width: 50px;\n    min-width: 50px;\n    height: 50px;\n    font-size: 22px;\n    line-height: 30px;\n    margin-right: 10px;\n}\n\n.mediaTitle{\n    color: black !important;\n    font-weight: 900;\n}\n\n::ng-deep .mat-checkbox input {\n    top: 2px !important;\n    left: 2px !important;\n}\n\n@media only screen and (max-width: 576px) and (min-width: 320px) {\n    ::ng-deep .mat-dialog-content{\n        padding: 0;\n    }\n\n    .search-users {\n        margin-top: 18px;\n    }\n    .form-inline {\n        flex-flow: nowrap;\n    }\n    }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
